import {
  Grid,
  LinearProgress,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Dialog,
  Typography,
  DialogContent,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  TextField,
  Button,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Reports } from "../../../../../app/slices/reportsSlice";
import dayjs from "dayjs";
import { IoBarcodeOutline } from "react-icons/io5";
import DateRangepicker from "../../../../../helpers/dateRangePicker";
import { SelectPos } from "../../../../../components/Selectors/SelectPos";
import { SelectItem } from "../../../../../components/Selectors/SelectItems";
import { SelectRepresentative } from "../../../../../components/Selectors/SelectRepresentative";
import { MdOutlineClear } from "react-icons/md";
import { SelectGroup } from "../../../../../components/Selectors/SelectGroup";
import { SelectSubCategory } from "../../../../../components/Selectors/SelectSubCategory";
import { SelectProvince } from "../../../../../components/Selectors/SelectProvince";
import { SelectCity } from "../../../../../components/Selectors/SelectCity";
import { setCityTable } from "../../../../../app/slices/provincesSlice";
import { SelectTeamLeader } from "../../../../../components/Selectors/SelectTeamLeader";

const OrdersTabel = () => {
  const dispatch = useDispatch();

  const [reportType, setReportType] = useState("basic");

  const handleChange = (event, newType) => {
    setReportType(newType);
  };
  const [search, setSearch] = useState({
    start_date: dayjs().format("YYYY-MM-01"),
    end_date: dayjs().format("YYYY-MM-DD"),
    pos: [],
    items: [],
    rep: null,
    group_id: null,
    province_id: null,
    supervisor_id: null,
    sub_category_id: null,
  });

  const [result, setResult] = useState({ total_amounts: 0, total_revenus: 0 });
  const [openDialog, setOpenDialog] = useState(false);

  const _Orders = useSelector((state) => state.reports.orders);
  const _OrdersDetailed = useSelector((state) => state.reports.ordersDetailed);
  const _PosOrders = useSelector((state) => state.reports.posOrders);
  const _OrdersPinsDetailed = useSelector(
    (state) => state.reports.ordersPinsDetails,
  );
  const loading = useSelector((state) => state.reports.reports.loading);
  const _items = useSelector((state) => state.items.itemsList.data);
  const _provinces = useSelector((state) => state.provinces.provinces.data);
  const _Cities = useSelector((state) => state.provinces.cities.data);
  const _PointOfsales = useSelector(
    (state) => state.pointOfsales.posesList.data,
  );
  const _SoldPins = useSelector((state) => state.reports.soldPins);
  const _Group = useSelector((state) => state.group.groupsList.data);
  const _TeamLeader = useSelector((state) => state.team.leaders);
  const user = useSelector((state) => state.user.usersList.data);
  const _SubCategory = useSelector(
    (state) => state.subCategories.subCategoriesList.data,
  );
  const _Permissions = useSelector((state) => state.user.userInfo.permissions);

  const _UserInfo = useSelector((state) => state.user.userInfo);
  const PRIVILEGED_USER_ID = "aba4cd5e-7d97-43c9-b287-5cd6a4d566d7";

  var is_super_admin = localStorage.getItem("role") === "super_admin";
  var is_team_leader = localStorage.getItem("role") === "team_leader";
  var is_admin = localStorage.getItem("role") === "admin";

  const [provinceId, setProvinceId] = useState(false);

  useEffect(() => {
    const selectedCities = _provinces?.filter((x) =>
      x.id === provinceId ? x.city : null,
    )[0];
    dispatch(setCityTable(selectedCities?.city));
  }, [provinceId, _provinces, dispatch]);

  var columns = [
    {
      field: "id",
      headerName: "#",
      flex: 0.4,
    },
    {
      field: "pos_name",
      headerName: "اسم نقطة البيع",
      flex: 1,
    },
    {
      field: "item_name",
      headerName: "اسم المنتج",
      flex: 1,
    },
    {
      field: "count",
      headerName: "العدد",
      flex: 1,
      renderCell: (params) => {
        return <>{parseInt(params.row.count)}</>;
      },
    },
    {
      field: "total_amount",
      headerName: "المبلغ الكلي (IQD)",
      flex: 1,
      renderCell: (params) => {
        return <>{parseInt(params.row.total_amount).toLocaleString()}</>;
      },
    },
    {
      field: "revenue",
      headerName: "الارباح (IQD)",
      flex: 1,
      renderCell: (params) => parseInt(params.row.revenue).toLocaleString(),
    },
    {
      field: "pins_details",
      headerName: "تفاصيل الكودات",
      flex: 1,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            <IoBarcodeOutline />
          </IconButton>
        );
      },
    },
  ];

  columns =
    is_super_admin || is_team_leader || is_admin
      ? columns
      : columns.filter((x) => x.field !== "pins_details");
  columns =
    is_super_admin ||
    is_team_leader ||
    is_admin ||
    _UserInfo.id === PRIVILEGED_USER_ID
      ? columns
      : columns.filter((x) => x.field !== "total_amount");
  columns =
    is_super_admin || _UserInfo.id === PRIVILEGED_USER_ID
      ? columns
      : columns.filter((x) => x.field !== "revenue");
  columns =
    reportType === "detailed"
      ? columns
      : columns.filter((x) => x.field !== "pos_name");
  columns =
    reportType === "detailed"
      ? columns
      : columns.filter((x) => x.field !== "pins_details");
  const pinsColumns = [
    {
      field: "id",
      headerName: "#",
      flex: 1,
    },
    {
      field: "serial_number",
      headerName: "الرقم التسلسلي",
      flex: 1,
    },
    {
      field: "pin_number",
      headerName: "الرقم السري",
      flex: 1,
    },
    {
      field: "order_date",
      headerName: "تاريخ البيع",
      flex: 1,
      valueGetter: (params) =>
        params.row.order_date
          ? dayjs(params.row.order_date).format(" YYYY-MM-DD")
          : "",
      renderCell: (params) => {
        return <>{dayjs(params.row.order_date).format("YYYY-MM-DD")}</>;
      },
    },
    {
      field: "order_id",
      headerName: "رقم الطلب",
      flex: 1,
    },
  ];

  const ordersPinsColumns = [
    {
      field: "id",
      headerName: "#",
      flex: 1,
    },
    {
      field: "serial_number",
      headerName: "الرقم التسلسلي",
      flex: 1,
    },
    {
      field: "pin_number",
      headerName: "الرقم السري",
      flex: 1,
    },
    {
      field: "order_date",
      headerName: "تاريخ البيع",
      flex: 1,
      valueGetter: (params) =>
        params.row.order_date
          ? dayjs(params.row.order_date).format(" YYYY-MM-DD")
          : "",
      renderCell: (params) => {
        return <>{dayjs(params.row.order_date).format("YYYY-MM-DD")}</>;
      },
    },
    {
      field: "order_id",
      headerName: "رقم الطلب",
      flex: 1,
    },
    {
      field: "item_name",
      headerName: "اسم المنتج",
      flex: 1,
    },
    {
      field: "pos_name",
      headerName: "اسم نقطة البيع",
      flex: 1,
    },
  ];

  const posOrdersColumns = [
    {
      field: "id",
      headerName: "#",
      flex: 0.5,
    },
    {
      field: "name",
      headerName: "اسم النقطة",
      flex: 1,
      renderCell: (params) => (
        <Box
          onClick={() => {
            localStorage.setItem("isWholeSale", "0");
            window.open(
              "/app/wallets/transactions/" + params.row.user_id,
              "_blank",
            );
          }}
        >
          <Typography
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "primary.main",
            }}
          >
            {params.row.name}
          </Typography>
        </Box>
      ),
    },
    {
      field: "pos_number",
      headerName: "رقم النقطة",
      flex: 1,
    },
    {
      field: "rep_name",
      headerName: "اسم المندوب",
      flex: 1,
    },
    {
      field: "total_amount",
      headerName: "مجموع المبيعات",
      flex: 1,
      renderCell: (params) => {
        return <>{parseInt(params.row.total_amount).toLocaleString()}</>;
      },
    },
  ];
  useEffect(() => {
    var total_amount = 0;
    var total_revenu = 0;
    _Orders.data.forEach((element) => {
      total_amount += parseInt(element.total_amount);
      total_revenu += parseInt(element.revenue);
    });
    setResult({ total_amounts: total_amount, total_revenus: total_revenu });
  }, [_Orders.data]);

  useEffect(() => {
    var total_amount = 0;
    var total_revenu = 0;
    _OrdersDetailed.data.forEach((element) => {
      total_amount += parseInt(element.total_amount);
      total_revenu += parseInt(element.revenue);
    });
    setResult({ total_amounts: total_amount, total_revenus: total_revenu });
  }, [_OrdersDetailed.data]);

  const handleSearch = () => {
    if (reportType === "detailed") {
      dispatch(
        Reports.getOrdersDetailed({
          start_date: search.start_date,
          end_date: search.end_date,
          pos: search.pos,
          items: search.items,
          rep_id: search.rep,
          group_id: search.group_id,
          province_id: search.province_id,
          supervisor_id: search.supervisor_id,
          city_id: search.city_id,
          sub_category_id: search.sub_category_id,
        }),
      );
    } else if (reportType === "basic") {
      dispatch(
        Reports.getOrders({
          start_date: search.start_date,
          end_date: search.end_date,
          pos: search.pos,
          items: search.items,
          rep_id: search.rep,
          group_id: search.group_id,
          province_id: search.province_id,
          supervisor_id: search.supervisor_id,
          city_id: search.city_id,
          sub_category_id: search.sub_category_id,
        }),
      );
    } else if (reportType === "pinsDetailes") {
      dispatch(
        Reports.getordersPinsDetails({
          start_date: search.start_date,
          end_date: search.end_date,
          pos_id: search.pos,
          item_id: search.items,
          supervisor_id: search.supervisor_id,
        }),
      );
    } else if (reportType === "posOrders") {
      dispatch(
        Reports.getPosOrders({
          start_date: search.start_date,
          end_date: search.end_date,
          min_orders_amount: search.min_orders_amount,
          supervisor_id: search.supervisor_id,
          rep_id: search.rep,
        }),
      );
    }
  };

  const customToolbar = () => (
    <GridToolbarContainer>
      <Stack direction={"row"} spacing={3}>
        <GridToolbarExport
          csvOptions={{
            fileName: "تقرير المبيعات | نظام دجلة",
            utf8WithBom: true,
          }}
        />
        {(is_super_admin || is_team_leader || is_admin) &&
          (reportType === "basic" || reportType === "detailed") && (
            <Typography sx={{ marginTop: 1 }}>
              مجموع المبيعات الكلي: {result.total_amounts.toLocaleString()}
            </Typography>
          )}
        {is_super_admin &&
          reportType &&
          (reportType === "basic" || reportType === "detailed") && (
            <Typography sx={{ marginTop: 1 }}>
              مجموع الارباح الكلي: {result.total_revenus.toLocaleString()}
            </Typography>
          )}
      </Stack>
    </GridToolbarContainer>
  );

  return (
    <Card>
      <CardContent>
        <Dialog
          open={openDialog}
          keepMounted
          fullWidth={true}
          dir="rtl"
          onClose={() => {
            setOpenDialog(false);
          }}
          aria-describedby="alert-dialog-slide-description"
          maxWidth="md"
        >
          <DialogContent>
            <Typography
              mb={3}
              variant="h4"
              color={"purple"}
              gutterBottom
              component="div"
            >
              تفاصيل الكودات
            </Typography>
            <Box sx={{ height: "70vh" }}>
              {_SoldPins.data ? (
                <DataGrid
                  rows={_SoldPins.data.map((data, index) => {
                    return { ...data, id: index + 1 };
                  })}
                  columns={pinsColumns}
                  rowCount={_SoldPins.total}
                  loading={loading}
                  rowHeight={30}
                  components={{
                    LoadingOverlay: LinearProgress,
                    Toolbar: customToolbar,
                  }}
                />
              ) : (
                <LinearProgress />
              )}
            </Box>
          </DialogContent>
        </Dialog>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <ToggleButtonGroup
              color="primary"
              value={reportType}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              {!is_team_leader || !is_admin ? (
                <ToggleButton
                  value="basic"
                  onClick={() =>
                    setSearch({
                      ...search,
                      start_date: dayjs().format("YYYY-MM-01"),
                      end_date: dayjs().format("YYYY-MM-DD"),
                    })
                  }
                >
                  التقرير العادي
                </ToggleButton>
              ) : null}
              {!is_team_leader || !is_admin ? (
                <ToggleButton
                  value="detailed"
                  onClick={() =>
                    setSearch({
                      ...search,
                      start_date: dayjs().format("YYYY-MM-DD"),
                      end_date: dayjs().format("YYYY-MM-DD"),
                    })
                  }
                >
                  التقرير المفصل
                </ToggleButton>
              ) : null}
              {console.log(_Permissions)}
              {(is_super_admin ||
                is_team_leader ||
                is_admin ||
                _Permissions
                  .map((x) => x.name)
                  .includes("orders_pins_details_report")) && (
                <ToggleButton
                  value="pinsDetailes"
                  onClick={() =>
                    setSearch({
                      ...search,
                      start_date: dayjs().format("YYYY-MM-DD"),
                      end_date: dayjs().format("YYYY-MM-DD"),
                    })
                  }
                >
                  تفاصيل الكودات
                </ToggleButton>
              )}
              {(is_super_admin ||
                is_team_leader ||
                is_admin ||
                _Permissions
                  .map((x) => x.name)
                  .includes("pos_orders_report")) && (
                <ToggleButton
                  value="posOrders"
                  onClick={() =>
                    setSearch({
                      ...search,
                      start_date: dayjs().format("YYYY-MM-DD"),
                      end_date: dayjs().format("YYYY-MM-DD"),
                    })
                  }
                >
                  مبيعات النقاط
                </ToggleButton>
              )}
            </ToggleButtonGroup>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              disabled={loading}
            >
              بحث
            </Button>
          </Grid>
          {!is_team_leader || !is_admin ? (
            <Grid item xs={12} sx={{ marginBottom: 2 }}>
              <Divider />
            </Grid>
          ) : null}
          <Grid item xs={12} md={3}>
            <DateRangepicker
              disabled={loading}
              startDate={search.start_date}
              endDate={search.end_date}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    start_date: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD",
                    ),
                    end_date: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          {(is_super_admin || is_team_leader || is_admin) &&
          reportType !== "posOrders" ? (
            <Grid item xs={2}>
              <SelectPos
                disabled={loading}
                multiple
                onChange={(event, value) => {
                  var ids = value.map((x) => x.id);
                  setSearch({
                    ...search,
                    pos: value ? ids : null,
                  });
                }}
                value={
                  _PointOfsales?.filter((x) => search.pos?.includes(x.id)) ?? []
                }
              />
            </Grid>
          ) : null}
          {is_super_admin || is_team_leader || is_admin
            ? (reportType === "detailed" || reportType === "basic") && (
                <Grid item xs={12} md={2}>
                  <SelectGroup
                    disabled={loading}
                    onChange={(e, newValue) => {
                      setSearch({
                        ...search,
                        group_id: newValue ? newValue.id : null,
                      });
                    }}
                    value={
                      _Group.filter(
                        (group) => group.id === search.group_id,
                      )[0] ?? null
                    }
                  />
                </Grid>
              )
            : null}
          {is_super_admin || is_team_leader || is_admin
            ? (reportType === "detailed" || reportType === "basic") && (
                <Grid item xs={12} md={2}>
                  <SelectProvince
                    disabled={loading}
                    onChange={(e, newValue) => {
                      setProvinceId(newValue ? newValue.id : null);
                      setSearch({
                        ...search,
                        province_id: newValue ? newValue.id : null,
                      });
                    }}
                    value={
                      _provinces?.filter((x) => x.id === provinceId)[0] ?? null
                    }
                  />
                </Grid>
              )
            : null}
          {is_super_admin || is_team_leader || is_admin
            ? reportType === "basic" && (
                <Grid item xs={12} md={2}>
                  <SelectCity
                    onChange={(e, newValue) => {
                      setSearch({
                        ...search,
                        city_id: newValue ? newValue.id : null,
                      });
                    }}
                    value={
                      _Cities?.filter((x) => x.id === search.city_id)[0] ?? null
                    }
                  />
                </Grid>
              )
            : null}
          {is_super_admin && reportType !== "posOrders" && (
            <Grid item xs={12} md={2}>
              <SelectItem
                disabled={loading}
                multiple
                onChange={(event, value) => {
                  var ids = value.map((x) => x.id);
                  setSearch({
                    ...search,
                    items: value ? ids : null,
                  });
                }}
                value={
                  _items?.filter((x) => search.items?.includes(x.id))
                    ? _items?.filter((x) => search.items?.includes(x.id))
                    : []
                }
              />
            </Grid>
          )}
          {is_super_admin && reportType !== "posOrders" && (
            <Grid item xs={12} md={2}>
              <SelectSubCategory
                disabled={loading}
                onChange={(event, value) => {
                  setSearch({
                    ...search,
                    sub_category_id: value ? value.id : null,
                  });
                }}
                value={
                  _SubCategory?.filter(
                    (x) => x.id === search.sub_category_id,
                  )[0] ?? null
                }
              />
            </Grid>
          )}
          {is_super_admin || is_team_leader || is_admin
            ? reportType === "posOrders" && (
                <Grid item xs={12} md={2}>
                  <TextField
                    label="اقل قيمة للمبيعات"
                    size="small"
                    fullWidth
                    value={search.min_orders_amount ?? ""}
                    onChange={(e) => {
                      setSearch({
                        ...search,
                        min_orders_amount: e.target.value,
                      });
                    }}
                  />
                </Grid>
              )
            : null}
          {(is_super_admin || is_team_leader || is_admin) &&
            (reportType === "detailed" ||
              reportType === "basic" ||
              reportType === "posOrders") && (
              <Grid item xs={12} md={2}>
                <SelectRepresentative
                  disabled={loading}
                  onChange={(event, value) => {
                    setSearch({
                      ...search,
                      rep: value ? value.id : null,
                    });
                  }}
                  value={user?.filter((x) => x.id === search.rep)[0] ?? null}
                />
              </Grid>
            )}
          {(is_super_admin || is_team_leader || is_admin) && (
            <Grid item xs={12} md={2}>
              <SelectTeamLeader
                disabled={loading}
                supervisor_id={"true"}
                onChange={(event, value) => {
                  setSearch({
                    ...search,
                    supervisor_id: value ? value.id : null,
                  });
                }}
                value={
                  _TeamLeader.data?.filter(
                    (x) => x.id === search.supervisor_id,
                  )[0] ?? null
                }
              />
            </Grid>
          )}
          <Grid item xs={1}>
            <Stack direction="row" justifyContent="center" alignItems="center">
              {/* <IconButton
                disabled={loading}
                onClick={() => {
                  setSearch({ ...search });
                }}
              >
                <Tooltip title="بحث">
                  <span>
                    <MdOutlineSearch />
                  </span>
                </Tooltip>
              </IconButton> */}
              <IconButton
                disabled={loading}
                onClick={() => {
                  // Reset all filters
                  setSearch({
                    start_date:
                      reportType === "detailed"
                        ? dayjs().format("YYYY-MM-DD")
                        : dayjs().format("YYYY-MM-01"),
                    end_date: dayjs().format("YYYY-MM-DD"),
                    pos: [],
                    items: [],
                    rep: null,
                    group_id: null,
                    province_id: null,
                    supervisor_id: null,
                    city_id: null,
                    sub_category_id: null,
                    min_orders_amount: "",
                  });
                  setProvinceId(null);
                  // Fetch data after clearing filters
                  if (reportType === "detailed") {
                    dispatch(
                      Reports.getOrdersDetailed({
                        start_date: dayjs().format("YYYY-MM-DD"),
                        end_date: dayjs().format("YYYY-MM-DD"),
                        pos: [],
                        items: [],
                        rep_id: null,
                        group_id: null,
                        province_id: null,
                        supervisor_id: null,
                        city_id: null,
                        sub_category_id: null,
                        min_orders_amount: "",
                      }),
                    );
                  } else if (reportType === "basic") {
                    dispatch(
                      Reports.getOrders({
                        start_date: dayjs().format("YYYY-MM-01"),
                        end_date: dayjs().format("YYYY-MM-DD"),
                        pos: [],
                        items: [],
                        rep_id: null,
                        group_id: null,
                        province_id: null,
                        supervisor_id: null,
                        city_id: null,
                        sub_category_id: null,
                        min_orders_amount: "",
                      }),
                    );
                  } else if (reportType === "pinsDetailes") {
                    dispatch(
                      Reports.getordersPinsDetails({
                        start_date: dayjs().format("YYYY-MM-DD"),
                        end_date: dayjs().format("YYYY-MM-DD"),
                        pos_id: [],
                        item_id: [],
                        supervisor_id: null,
                      }),
                    );
                  } else if (reportType === "posOrders") {
                    dispatch(
                      Reports.getPosOrders({
                        start_date: dayjs().format("YYYY-MM-DD"),
                        end_date: dayjs().format("YYYY-MM-DD"),
                        min_orders_amount: "",
                        supervisor_id: null,
                      }),
                    );
                  }
                }}
              >
                <Tooltip title="الغاء الفلتر">
                  <span>
                    <MdOutlineClear />
                  </span>
                </Tooltip>
              </IconButton>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            {reportType === "detailed" ? (
              <Box sx={{ height: "64vh", width: "100%" }}>
                {_OrdersDetailed.data ? (
                  <DataGrid
                    rows={_OrdersDetailed.data?.map((data, index) => {
                      return { ...data, id: index + 1 };
                    })}
                    getRowId={(row) => row.id}
                    columns={columns}
                    rowCount={_OrdersDetailed.total}
                    loading={loading}
                    rowHeight={30}
                    selectionModel={[]}
                    components={{
                      LoadingOverlay: LinearProgress,
                      Toolbar: customToolbar,
                    }}
                  />
                ) : (
                  <LinearProgress />
                )}
              </Box>
            ) : reportType === "basic" ? (
              <Box sx={{ height: "64vh", width: "100%" }}>
                {_Orders.data ? (
                  <DataGrid
                    rows={_Orders.data?.map((data, index) => {
                      return { ...data, id: index + 1 };
                    })}
                    getRowId={(row) => row.id}
                    columns={columns}
                    rowCount={_Orders.total}
                    loading={loading}
                    rowHeight={30}
                    selectionModel={[]}
                    components={{
                      LoadingOverlay: LinearProgress,
                      Toolbar: customToolbar,
                    }}
                  />
                ) : (
                  <LinearProgress />
                )}
              </Box>
            ) : reportType === "posOrders" ? (
              <Box sx={{ height: "64vh", width: "100%" }}>
                {_PosOrders.data ? (
                  <DataGrid
                    rows={_PosOrders.data?.map((data, index) => {
                      return { ...data, id: index + 1 };
                    })}
                    getRowId={(row) => row.id}
                    columns={posOrdersColumns}
                    rowCount={_PosOrders.total}
                    loading={loading}
                    rowHeight={30}
                    selectionModel={[]}
                    components={{
                      LoadingOverlay: LinearProgress,
                      Toolbar: customToolbar,
                    }}
                  />
                ) : (
                  <LinearProgress />
                )}
              </Box>
            ) : (
              <Box sx={{ height: "64vh", width: "100%" }}>
                <DataGrid
                  rows={_OrdersPinsDetailed.data?.map((data, index) => {
                    return { ...data, id: index + 1 };
                  })}
                  getRowId={(row) => row.id}
                  columns={ordersPinsColumns}
                  rowCount={_Orders.total}
                  loading={loading}
                  rowHeight={30}
                  selectionModel={[]}
                  components={{
                    LoadingOverlay: LinearProgress,
                    Toolbar: customToolbar,
                  }}
                />
              </Box>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default OrdersTabel;
